
import { defineComponent, ref, onMounted } from "vue";
import { ThumbnailsPreview } from "@ajia/vue-next-ppt-component";
import { getSlideDataById, getUserPptSlide } from "@/api/index_test";

const ThumbsStatic = {
    border: 2,
    padding: 20,
    size: 120,
    count: 7,
    space: 22,
    platform: {
        pc: "pc",
        app: "app",
    },
};

export default defineComponent({
    name: "thumbs",
    components: {
        ThumbnailsPreview: ThumbnailsPreview as any,
    },
    emits: ["change"],
    setup() {
        const slideData = ref({});
        const getSlideData = async () => {
            let url = location.href;
            let id = url.split("id=")[1];
            if (url.indexOf("user_ppt_id") === -1) {
                const { data } = await getSlideDataById({ id: id });
                slideData.value = data;
            } else {
                const res = await getUserPptSlide({ id: id, slideIndex: 0 });
                slideData.value = { slides: [res.data] };
            }
            // if (url.indexOf("localhost") === -1 && url.indexOf("192.") === -1) {
            //   let id = url.split("id=")[1];
            //   if (url.indexOf("user_ppt_id") === -1) {
            //     const { data } = await getSlideDataById({ id: id });
            //     slideData.value = data;
            //   } else {
            //     const slide  = await getUserPptSlide({ id: id, slideIndex: 0 });
            //     slideData.value = {slides: [slide]};
            //   }
            // } else {
            //   slideData.value = {
            //     slides,
            //   };
            // }
        };
        onMounted(() => {
            getSlideData();
        });
        return {
            slideData,
        };
    },
});
